import React, { Component } from "react";

import { Row, Col, Grid } from "react-bootstrap";
import BannerRectangle from "../Banner/BannerRectangle";

class Sidebar extends Component {
  render() {
    return (
      <div>
        <Row style={{ margin: "0px" }}>
          <BannerRectangle osCode={this.props.osCode} agency={this.props.agency} />
        </Row>
        <Row style={{ margin: "0px" }}>
          <BannerRectangle osCode={this.props.osCode} agency={this.props.agency}/>
        </Row>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js